"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInvoicePaymentCreate = exports.paymentSchema = void 0;
var _joi = _interopRequireDefault(require("joi"));
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const paymentSchema = exports.paymentSchema = {
  received_at: _joi.default.string().trim().label("Receive Date").required(),
  amount: _joi.default.alternatives().try(_joi.default.number().min(0.01), _joi.default.number().max(-0.01)).label("Amount").required(),
  payment_method: _joi.default.string().trim().valid(...Object.values(_constants.PaymentMethods)).label("Payment Method").required(),
  note: _joi.default.string().allow("").trim()
};
const validateInvoicePaymentCreate = (payment, schema) => {
  return _joi.default.object(schema).validateAsync(payment, {
    convert: true,
    stripUnknown: true
  });
};
exports.validateInvoicePaymentCreate = validateInvoicePaymentCreate;